import React, { useState } from 'react';
import { Phone, Mail, Clock, ArrowRight } from 'lucide-react';

const Contact = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const form = e.target;
    const formData = new FormData(form);

    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(formData).toString(),
    })
      .then(() => {
        setFormSubmitted(true);
        form.reset();
      })
      .catch((error) => alert('Error submitting form. Please try again.'));
  };

  return (
    <section className="contact">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Request a Quote</h2>
          <p className="section-description">
            Contact us today for a consultation for your project.
          </p>
        </div>
        <div className="contact-container">
          <div className="contact-info">
            <div className="contact-cards">
              <div className="contact-card">
                <div className="contact-card-icon">
                  <Phone size={24} />
                </div>
                <div className="contact-card-content">
                  <h3>Phone</h3>
                  <p>(518) 792-0200</p>
                </div>
              </div>
              <div className="contact-card">
                <div className="contact-card-icon">
                  <Mail size={24} />
                </div>
                <div className="contact-card-content">
                  <h3>Email</h3>
                  <p>fredbartlettenterprises@gmail.com</p>
                </div>
              </div>
              <div className="contact-card">
                <div className="contact-card-icon">
                  <Clock size={24} />
                </div>
                <div className="contact-card-content">
                  <h3>Business Hours</h3>
                  <p>Mon-Fri: 8AM-5PM<br />Sat-Sun: By Appointment</p>
                </div>
              </div>
            </div>
          </div>

          {!formSubmitted ? (
            <form className="contact-form" name="contact" method="POST" data-netlify="true" onSubmit={handleSubmit}>
              <input type="hidden" name="form-name" value="contact" />
              <h3 style={{ marginBottom: '1.5rem', fontSize: '1.5rem', fontWeight: '700' }}>Send Us a Message</h3>
              
              <div className="form-group">
                <label>Full Name *</label>
                <input type="text" name="name" placeholder="John Smith" required />
              </div>
              <div className="form-group">
                <label>Email Address *</label>
                <input type="email" name="email" placeholder="john@example.com" required />
              </div>
              <div className="form-group">
                <label>Phone Number</label>
                <input type="tel" name="phone" placeholder="(555) 123-4567" />
              </div>
              <div className="form-group">
                <label>Service Needed</label>
                <input type="text" name="service" placeholder="e.g., Roofing, Siding, Windows" />
              </div>
              <div className="form-group">
                <label>Project Details *</label>
                <textarea name="message" placeholder="Tell us about your project..." required></textarea>
              </div>
              <button className="submit-button" type="submit">
                Send Message <ArrowRight size={20} />
              </button>
            </form>
          ) : (
            <div className="contact-form success-message">
              <div className="success-checkmark">✓</div>
              <h3 className="success-title">Thank You!</h3>
              <p className="success-description">
                Your message has been sent successfully. We'll get back to you as soon as possible!
              </p>
              <p className="success-contact">
                You can also call us at <strong>(518) 792-0200</strong>
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Contact;